import {gql} from '@apollo/client'

export const CREATE_UPDATE_ORGANIZATION = gql`
  mutation organizationCreateupdateMutation(
    $id: ID
    $name: String!
    $owner: String!
    $email: String!
    $phone: String!
    $website: String
    $streetAddress: String!
    $city: String!
    $country: String!
    $state: String
    $postalCode: String!
    $isActive: Boolean
    $logo: Upload
    $templateLogo: Upload
  ) {
    organizationCreateupdateMutation(
      input: {
        id: $id
        name: $name
        owner: $owner
        email: $email
        phone: $phone
        website: $website
        streetAddress: $streetAddress
        city: $city
        country: $country
        state: $state
        postalCode: $postalCode
        isActive: $isActive
        logo: $logo
        templateLogo: $templateLogo
      }
    ) {
      organization {
        id
        name
        owner
        email
        phone
        website
        streetAddress
        city
        country
        state
        postalCode
        logo
        templateLogo
        isActive
      }
      errors {
        field
        messages
      }
    }
  }
`

// String version for multipart file upload (logo)
export const CREATE_UPDATE_ORGANIZATION_STR = `
  mutation organizationCreateupdateMutation(
    $id: ID
    $name: String!
    $owner: String!
    $email: String!
    $phone: String!
    $website: String
    $streetAddress: String!
    $city: String!
    $country: String!
    $state: String
    $postalCode: String!
    $isActive: Boolean
    $logo: Upload
    $templateLogo: Upload
  ) {
    organizationCreateupdateMutation(
      input: {
        id: $id
        name: $name
        owner: $owner
        email: $email
        phone: $phone
        website: $website
        streetAddress: $streetAddress
        city: $city
        country: $country
        state: $state
        postalCode: $postalCode
        isActive: $isActive
        logo: $logo
        templateLogo: $templateLogo
      }
    ) {
      organization {
        id
        name
        owner
        email
        phone
        website
        streetAddress
        city
        country
        state
        postalCode
        logo
        templateLogo
        isActive
      }
      errors {
        field
        messages
      }
    }
  }
`

